/*eslint-disable*/
export default {
  init() {
    $('.jobs__wrapper div').each(function(){
      $(this).children('div:first').show();
  });
  
  $('.jobs__wrapper ul li').click(function() {
      var $self = $(this);
      var $nav = $(this).parent();
      var $tabCtl = $nav.parent();
      $nav.find('a').removeClass("active");
      $self.find('a').addClass("active");
      $tabCtl.children('div').children('div').hide();
  
      var indexer = $self.index(); //gets the current index of (this) which is #nav li
      
      $tabCtl.children('div').children('div:eq(' + indexer + ')').fadeIn(); //uses whatever index the link has to open the corresponding box 
  });

  const swiperJobs = new Swiper(".header__jobs", {
    loop: true,
    slidesPerView: 1,
    direction: "vertical",
    effect: "fade",
    speed: 900,
    fadeEffect: {
      crossFade: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
